import { Button, CircularProgress, Box } from "@mui/material"
import { ContentContainer } from "components/content-container"
import { spacing } from "deprecated-theme"
import React from "react"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()(
  (_theme) => ({
    rootContainer: {
      position: "fixed",
      right: 0,
      left: 0,
      bottom: 0,
      display: "flex",
      paddingBottom: 10,
      paddingTop: 10,
      borderTopWidth: 1,
      borderTopStyle: "solid",
      borderTopColor: "rgb(230, 236, 240)",
      pointerEvents: "auto",
      backgroundColor: "rgba(255, 255, 255, 1)",
      alignItems: "stretch",
      flexBasis: "auto",
      flexDirection: "column",
      flexShrink: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      minHeight: 0,
      minWidth: 0,
      zIndex: 20,
      "@media screen and (min-width: 1024px)": {
        bottom: 0,
        paddingTop: `${spacing[5]}px`,
        paddingBottom: `${spacing[5]}px`,
      },
    },
  })
)

interface IFloatingBottomButton {
  onPress?: () => void
  buttonText?: string
  buttonLoading?: boolean
  buttonDisabled?: boolean
  children?: React.ReactNode
}

export const FloatingBottomButton = (props: IFloatingBottomButton) => {
  const {
    buttonText = "Continue",
    onPress,
    buttonLoading: loading,
    buttonDisabled = false,
    children,
  } = props

  const { classes } = useStyles()
  return (
    <Box className={classes.rootContainer} sx={{ bottom: 0 }}>
      <ContentContainer>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          maxWidth={["100%", "100%", "550px"]}>
          {children}
          {children && <div style={{ height: "10px" }} />}
          <Button
            onClick={onPress}
            color="primary"
            variant="contained"
            size="large"
            disabled={buttonDisabled || loading}>
            {!loading && buttonText}
            {loading && <CircularProgress size={14} />}
          </Button>
        </Box>
      </ContentContainer>
    </Box>
  )
}
